import { styled } from "@mui/material/styles";

// Convert to actual styled components instead of a function returning style objects
export const Wrapper = styled("div")({
  position: "sticky",
  top: 0,
  zIndex: 999,
  backgroundColor: "#3b3a3a"
});

export const NotificationContainer = styled("div")({
  height: "64px",
  display: "flex",
  justifyContent: "space-between"
});

export const NotificationText = styled("p")({
  fontSize: "16px",
  color: "#fff",
  lineHeight: "1.19",
  fontStyle: "normal",
  fontWeight: "normal",
  fontStretch: "normal",
  margin: 0,
  paddingTop: "12px",
  paddingBottom: "14px",
  paddingRight: "24px",
  paddingLeft: "16px"
});

export const CloseIconWrapper = styled("div")({
  padding: "20px 20px 0 0",
  alignItems: "flex-start"
});

export const StyledCloseIcon = styled("div")({
  width: 24,
  right: 20,
  top: 20,
  cursor: "pointer"
});
